import {
  NBA_ALL_TIME_GREATS_DEFAULT,
  NBA_ALL_TIME_GREATS_STATS,
  getNbaAllTimeGreatsStat,
} from "../constants/nbaAllTimeGreats";

export {
  filterLeaderboardRowsByName,
  splitGreatsRows,
  buildGreatsGalleryItems,
  clampGalleryIndex,
  stepGalleryIndex,
  findGalleryIndex,
  reconcileGalleryIndex,
  galleryStepFromKey,
} from "./allTimeGreats";

export const parseNbaAllTimeGreatsSearch = (searchParams) => {
  const statParam = searchParams?.get?.("stat");
  const stat = NBA_ALL_TIME_GREATS_STATS[statParam]
    ? statParam
    : NBA_ALL_TIME_GREATS_DEFAULT.stat;
  return { stat };
};

export const serializeNbaAllTimeGreatsSearch = ({ stat }) => {
  const resolved = parseNbaAllTimeGreatsSearch({
    get: (key) => (key === "stat" ? stat : null),
  });
  const params = new URLSearchParams();
  params.set("stat", resolved.stat);
  return params;
};

export const getNbaGreatsQualifier = (statKey) =>
  getNbaAllTimeGreatsStat(statKey).qualifier || null;
